import * as React from 'react';

import { Desktop } from '../../../../../../packages/Responsive';
import { MapLayer } from '../../../../../components/MapLayer';
import { HelpLinkButton } from './HelpLinkButton';
import { trackHelpClick } from './tracking';
import * as styles from './styles.css';

export const HelpLinkButtonContainer: React.FC = () => {
  const url = '/contacts/?from_map=1';

  return (
    <Desktop>
      <MapLayer className={styles['layer']}>
        <HelpLinkButton href={url} onClick={trackHelpClick} />
      </MapLayer>
    </Desktop>
  );
};

HelpLinkButtonContainer.displayName = 'HelpLinkButtonContainer';
